import { ref, provide as vueProvide, inject as vueInject, Ref } from 'vue';
import { ZoomSetting } from '@/api/openapi';
import { ZoomSettingApiService } from '@/api/user/resources/zoom_setting';

const INJECTION_KEY = Symbol();

export const useZoomSettingProvider = () => {
  const provide = async () => {
    const zoomSetting = ref<ZoomSetting | null>(null);
    const fetchZoomSetting = async () => {
      const api = new ZoomSettingApiService();
      const { data: { zoomSetting: fetchedZoomSetting } } = await api.getZoomSetting();
      zoomSetting.value = fetchedZoomSetting;
    };
    vueProvide(INJECTION_KEY, {
      zoomSetting,
    });
    await fetchZoomSetting();
  };

  const inject = () => {
    return vueInject<{ zoomSetting: Ref<ZoomSetting | null> }>(INJECTION_KEY);
  };

  return {
    provide,
    inject,
  };
};
